/// <reference path="../store.js" />
import config from "../config.js";
import RequestManager from "./request.js";
//import router from "./../routeur.js"
export default class Patient {
    NumDossier;
    DateCreation;
    Nom;
    Prenom;
    DateNaissance;
    Adresse;
    CodePostal;
    LieuNaissance;
    TelD;

    Tel3;
    Tel4;
    Tel5;
    Tel6;

    Mail1;
    Mail2;
    Mail3;
    Mail4;

    TelP;
    Sexe;
    Ville;
    NumSecu;
    Commentaire;

    constructor(obj) {
        this.NumDossier = obj.NumDossier;
        this.DateCreation = obj.DateCreation;
        this.Nom = obj.Nom;
        this.Prenom = obj.Prenom;
        this.DateNaissance = obj.DateNaissance;
        this.Adresse = obj.Adresse;
        this.CodePostal = obj.CodePostal;
        this.TelP = obj.TelP;
        this.TelD = obj.TelD;
        this.Sexe = obj.Sexe;
        this.Ville = obj.Ville;
        this.NumSecu = obj.NumSecu;
        this.Commentaire = obj.Commentaire;
        
        this.Tel3 = obj.Tel3;
        this.Tel4 = obj.Tel4;
        this.Tel5 = obj.Tel5;
        this.Tel6 = obj.Tel6;

        this.Mail1 = obj.Mail1;
        this.Mail2 = obj.Mail2;
        this.Mail3 = obj.Mail3;
        this.Mail4 = obj.Mail4;
    }

    static patientCourant;

    static getPatientById(id, appliLance) {
        var url = config.urlBackEnd + 'Patient/afficherInfoPatient?id=' + id + "&appliLance=" + appliLance;
        return RequestManager.get(url);
    }
    static async getPatientBySearch(critere) {
        try {
            const response = await RequestManager.get(`${config.urlBackEnd}Patient/getPatientBySearch?critere=${critere}`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la réceptions des patients :", error);
            throw error;
        }
        
    }
    static async getPatientByInfos(jsonInfosPatient) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}Patient/getPatientByInfos`, jsonInfosPatient);
            return response;
        } catch (error) {
            console.error("Erreur lors de la réceptions des patients :", error);
            throw error;
        }
    }

    //static getPatientBySearch(critere, appliLance) {
    //    //https://localhost:44328/Patient/getPatientsBySearchWithApp?critere=a&appliLance=fisimed
    //    var url = config.urlBackEnd + 'Patient/getPatientsBySearchWithApp?critere=' + critere + "&appliLance=" + appliLance;
        
    //    return RequestManager.get(url);
    //}
    static getPatientsBySearchWithApp(critere, appliLance) {
        //https://localhost:44328/Patient/getPatientsBySearchWithApp?critere=a&appliLance=fisimed
        var url = config.urlBackEnd + 'Patient/getPatientsBySearchWithApp?critere=' + critere + "&appliLance=" + appliLance;
        return RequestManager.get(url);
    } 
    static getAllPatientsWithApp(appliLance){
        var url = config.urlBackEnd + 'Patient/getAllPatientsWithApp?appliLance=' + appliLance;
        return RequestManager.get(url);
    }

    static ouvriBase(nomBase) {
        alert("Patient.ouvriBase " + nomBase)
        var url = config.urlBackEnd + "Patient/ouvriBase?nomBase=" + nomBase;
        fetch(url)
            .then(response => { return response.json() })
            .then(data => {
                return data;
            })
            .catch(error => alert("Erreur dans Patient ouvrireBase " + nomBase))
    }

    static TestPatientSaisie(patient) {
        var url = config.urlBackEnd + 'testPatientEnregistrer';
        return RequestManager.post(url, patient).then(response => {
            console.log(response);
            return response;
        }).catch(error => console.log("Erreur Patient TestPatientSaisie : " + error));
    }
    static async modifierPatient(patient) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}Patient/ModifPatient`, patient);
            return response;
        } catch (error) {
            console.log("Erreur lors de la modification du patient : ", error);
            throw error;
        }
    }

    static async getNewNir(newValue, rpps) {
        try {   
            const response = await RequestManager.post(`${config.urlBackEnd}Patient/getNewNir`, {
                newValue: newValue,
                rpps: rpps
            });
            return response;
        } catch (error) {
            console.error("Erreur lors de la récupération du nouveau numéro Nir et de la nouvelle clé Nir : ", error);
            throw error;
        }
    }

    static async getInfosVitale() {
        try {
            const response = RequestManager.get(`${config.urlBackEnd}Patient/getInfosVitale`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la récupération des informations de la carte vitale : ", error);
            throw error;
        }
    }

    static async enregistrerNouveauPatient(patient) {
        try {
            const response = RequestManager.post(`${config.urlBackEnd}Patient/enregistrerNouveauPatient`, patient);
            return response;
        } catch (error) {
            console.error("Erreur lors de l'enregistrement du nouveau patient : ", error);
            throw error;
        }
    }

    static async supprimerPatient(idPatient) {
        try {
            const response = RequestManager.post(`${config.urlBackEnd}Patient/supprimerPatient?idPatient=${idPatient}`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la suppression du patient : ", error);
            throw error;
        }
    }
}
